import React from 'react';
import { m } from 'framer-motion';
import { SectionTag } from '../ui/SectionTag';
export function TaglineCta() {
  return <section className="bg-primary py-10 sm:py-14" data-id="element-168" data-mp="yflgtzsrrpb0">
      <m.div initial={{
      opacity: 0,
      y: 14
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.45
    }} className="mx-auto max-w-3xl px-4 text-center sm:px-6" data-id="element-169" data-mp="12gnhml2c49f3">
        <SectionTag icon="🏆" tone="gold" data-id="element-170" data-mp="1cds5cpbtwcy0">
          El sistema N°1 para profesoras de Pilates de habla hispana
        </SectionTag>
        <h2 className="mt-5 font-heading text-2xl font-bold leading-tight text-white sm:text-3xl" data-id="element-171" data-mp="1hbjw3g0qlt0m">
          Enciclopedia Pilates 360 — Colección Completa
        </h2>
        <p className="mt-3 text-base leading-relaxed text-white/80 sm:text-lg" data-id="element-172" data-mp="1q4on1l47v9qa">
          6 Tomos + 6 Bonos Premium — Todo resuelto, todos los niveles, todos los aparatos.
        </p>
      </m.div>
    </section>;
}